import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-763f1dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cinema__header" }
const _hoisted_2 = { class: "cinema__header-content" }
const _hoisted_3 = { class: "cinema__header-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "cinema__header-operations" }
const _hoisted_6 = { class: "refresh-icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "refresh-label" }, "刷新", -1))
const _hoisted_8 = { class: "opera-item search-box-wrap" }
const _hoisted_9 = { class: "setting-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "setting-label" }, "来源管理", -1))

import { PropType, reactive, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import SVGIcon from '@remote/components/SVGIcon.vue'
import { useCinemaStore } from '@remote/store/cinema'
import { checkState } from '@remote/store/utils'
// import { isIOSNative, isAndroidNative } from '@xunlei/universal-native-api'
import { stat } from '@remote/utils/stat'
import { isLargeViewPort } from '@remote/utils/base'
// import { toast } from '@remote/utils/dialog'
import Modal from '@remote/components/modal'
// import { useEnvStore } from '@remote/store/env'
import { addScrapeDirs } from '@remote/api/adapter/shell-mqtt'
import SearchBox from '@remote/components/layout/SearchBox.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  slides: {
    type: Array as PropType<{ title: string; stat: string }[]>,
    required: true,
  },
  currentSlideIndex: {
    type: Number,
    default: 0,
  },
},
  emits: ['update:currentSlideIndex'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()


const cinemaStore = useCinemaStore()


const selectTab = (index: number) => {
  stat({
    action: 'cinema_tab_click',
    data: { click_id: props.slides[index].stat },
  })
  emit('update:currentSlideIndex', index)
}

const refreshRef = reactive({
  isRefreshing: false,
  lastTime: 0,
})

const isScraping = computed(() => {
  if (cinemaStore.isScraping) return true
  return isLargeViewPort() ? refreshRef.isRefreshing : false
})

function onRefresh () {
  if (isScraping.value) return
  if (checkState(true, true, true, false)) return
  refreshRef.isRefreshing = true
  refreshRef.lastTime = Date.now()
  addScrapeDirs()
  cinemaStore.createScrapeTask('manual_btn_click')
  // store.commit('toast', '正在刷新，刷新完毕会自动更新列表')
  stat({
    action: 'cinema_tab_click',
    data: { click_id: 'refresh' },
  })
}

watch(() => cinemaStore.isScraping, (isScraping) => {
  if (!isScraping) {
    const now = Date.now()
    const duration = now - refreshRef.lastTime
    if (duration > 3000) {
      refreshRef.isRefreshing = false
    } else {
      setTimeout(() => {
        refreshRef.isRefreshing = false
      }, 3000 - duration)
    }
  }
})

function gotoScrapeSettingPage () {
  stat({
    action: 'cinema_tab_click',
    data: { click_id: 'source_setting' },
  })
  const isPC = isLargeViewPort()
  if (!isPC) {
    router.push({
      name: 'scrapeSettings',
    })
  } else {
    // 刮削设置弹窗
    Modal.showScrapePathSettingModal({ mask: true })
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slides, (slide, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["cinema__header-tab", {
            'is-active': index === __props.currentSlideIndex,
          }]),
            key: slide.title,
            onClick: ($event: any) => (selectTab(index))
          }, _toDisplayString(slide.title), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["opera-item refresh-btn", { 'is-refreshing': _unref(isScraping) }]),
          onClick: onRefresh
        }, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(SVGIcon, { name: "refresh" })
          ]),
          _hoisted_7
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(SearchBox)
        ]),
        _createElementVNode("div", {
          class: "opera-item setting-btn",
          onClick: gotoScrapeSettingPage
        }, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(SVGIcon, { name: "setting" })
          ]),
          _hoisted_10
        ])
      ])
    ])
  ]))
}
}

})